import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";

import "../styles.scss";

export const balloonsFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.3306 9.789C7.69817 10.9542 5.60408 13.4219 5.04836 17.1923C4.78446 20.0344 5.60066 22.523 7.49685 24.6583C9.72727 26.761 12.3494 27.5196 15.3632 26.934C17.8845 26.3128 19.7558 24.8671 20.9771 22.5969C18.6126 19.9523 17.8727 16.9119 18.7574 13.4758C18.9077 13.0828 19.0408 12.6845 19.1568 12.2809C16.9503 10.1481 14.3415 9.31749 11.3306 9.789ZM11.001 11.2802C10.7658 11.3674 10.5306 11.4546 10.2955 11.5418C10.4268 11.8958 10.5581 12.2497 10.6894 12.6036C13.1633 11.8866 15.3176 12.4295 17.152 14.2324C17.4344 13.9957 17.6832 13.7289 17.8985 13.4321C15.9497 11.5651 13.6504 10.8479 11.001 11.2802Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.9365 8.60699C22.4703 9.29743 20.813 10.8516 19.9649 13.2695C19.0221 16.35 19.5556 19.1582 21.5652 21.6943C24.1074 24.2211 27.0236 24.7631 30.3142 23.3205C33.3539 21.4547 34.5866 18.7563 34.0123 15.225C33.1614 12.0047 31.1741 9.85642 28.0505 8.78048C27.016 8.51899 25.9781 8.46115 24.9365 8.60699ZM25.1712 9.88879C24.9361 9.97602 24.7009 10.0633 24.4657 10.1505C24.597 10.5044 24.7283 10.8583 24.8596 11.2122C26.3973 10.7198 27.8447 10.9075 29.2016 11.7756C29.5711 11.9989 29.8787 12.2874 30.1246 12.6411C30.3422 12.4906 30.5468 12.3208 30.7381 12.1317C30.8459 12.0496 30.9137 11.9439 30.9416 11.8147C29.3354 10.2037 27.412 9.5618 25.1712 9.88879Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.6749 27.3245C17.135 27.603 16.5794 27.836 16.008 28.0234C15.9666 28.4611 15.9142 28.8966 15.8506 29.3298C16.7905 29.0483 17.7032 28.6963 18.5888 28.2739C18.2493 27.9866 17.9447 27.6701 17.6749 27.3245Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.7211 24.4176C30.1813 24.696 29.6257 24.929 29.0543 25.1164C29.0129 25.5541 28.9604 25.9896 28.8969 26.4229C29.8368 26.1413 30.7495 25.7893 31.6351 25.3669C31.2964 25.0802 30.9917 24.7638 30.7211 24.4176Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.0491 29.1988C17.6729 29.3383 17.2966 29.4779 16.9204 29.6175C17.2903 31.1942 18.1389 32.4361 19.4662 33.3434C20.0531 33.5941 20.5808 33.9352 21.0495 34.3665C21.4291 34.9062 21.6244 35.5047 21.6354 36.1622C21.4544 36.9003 21.2735 37.6385 21.0925 38.3766C20.9233 40.275 21.2831 42.074 22.1717 43.7739C22.5479 43.6343 22.9242 43.4948 23.3004 43.3552C22.195 41.2317 22.0448 39.0596 22.8495 36.8391C23.1072 34.6925 22.2534 33.184 20.288 32.3138C19.1655 31.5568 18.4191 30.5184 18.0491 29.1988Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.7405 26.0525C31.2926 26.2187 30.8446 26.3849 30.3966 26.5511C31.3008 28.5092 31.2681 30.4388 30.2985 32.3398C29.9653 34.2636 30.5314 35.8752 31.9964 37.1746C33.8073 38.0961 35.0801 39.5094 35.8147 41.4146C36.2907 41.2381 36.524 41.1766 37 41C36.4293 39.3814 35.7136 37.9281 34.3678 36.8702C33.7674 36.4537 33.1671 36.0373 32.5667 35.6209C31.9146 34.8423 31.6476 33.9507 31.7655 32.946C32.8635 30.6533 32.8551 28.3555 31.7405 26.0525Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M84.3181 5.06677C87.795 5.77559 90.3092 7.71984 91.8609 10.8995C93.6824 14.9808 93.3194 18.8646 90.7718 22.551C88.5134 25.3226 85.5964 26.6727 82.0208 26.6013C82.2211 27.3975 82.373 28.2006 82.4764 29.0104C82.3683 29.1583 82.247 29.2952 82.1123 29.4211C81.2996 29.3261 80.4987 29.1538 79.7096 28.9044C79.4714 30.1785 78.8842 31.2634 77.948 32.1593C77.4156 32.6123 76.853 33.0262 76.26 33.4011C75.642 34.0845 75.3705 34.887 75.4455 35.8087C75.7169 36.5873 75.9882 37.3659 76.2596 38.1444C76.6369 40.1764 76.4316 42.1543 75.6438 44.0781C75.2223 43.9652 74.8008 43.8522 74.3793 43.7393C75.3584 41.3365 75.2988 38.9771 74.2007 36.661C73.7021 34.3698 74.4719 32.6561 76.51 31.5199C77.4768 30.7522 78.1218 29.7674 78.4451 28.5655C77.637 28.387 76.8573 28.1358 76.106 27.8117C76.0523 27.6354 76.0156 27.4561 75.9959 27.274C76.4905 26.6244 77.0235 26.0048 77.5951 25.4155C76.1179 24.619 74.8956 23.5433 73.9281 22.1883C72.1489 23.8381 70.0406 24.699 67.6033 24.7711C67.7591 25.4415 67.9032 26.1154 68.0357 26.7928C68.0298 27.1083 67.9162 27.3744 67.6948 27.5908C66.8821 27.4958 66.0812 27.3236 65.2921 27.0741C65.0056 28.1295 65.021 29.1783 65.3384 30.2206C65.7153 30.8538 66.0018 31.5234 66.1977 32.2296C66.4071 33.76 65.9812 35.0859 64.9201 36.2072C63.3531 37.195 62.004 39.711 61.5 41.5C61.0521 41.38 60.6044 41.26 60.1565 41.14C60.5362 39.6247 61.6058 37.2031 62.7383 36.1308C63.2483 35.7027 63.7582 35.2747 64.2682 34.8467C64.794 34.0859 64.9602 33.2552 64.7666 32.3544C63.9641 31.0494 63.6109 29.6277 63.7071 28.0894C63.7875 27.6317 63.8943 27.1803 64.0276 26.7353C63.286 26.5506 62.5519 26.3399 61.8254 26.1028C61.7609 26.0539 61.7056 25.9967 61.6595 25.9314C61.6102 25.6469 61.6544 25.3763 61.7923 25.1199C62.2456 24.5995 62.7074 24.0879 63.1776 23.5852C58.8953 20.5607 57.6097 16.5599 59.3209 11.5826C60.6862 8.41514 63.0068 6.3405 66.2826 5.35877C69.4102 4.71468 72.1024 5.52075 74.3591 7.77699C74.5856 8.01883 74.783 8.28347 74.9511 8.57089C77.4987 5.86477 80.621 4.69673 84.3181 5.06677ZM84.9276 6.58536C88.9088 8.0611 91.1233 10.9133 91.5712 15.1418C91.7329 19.6425 89.7712 22.8015 85.6861 24.6188C82.6005 25.6854 79.7163 25.2796 77.0336 23.4015C76.2045 22.7891 75.5124 22.053 74.9571 21.1934C77.4191 17.5486 77.688 13.7525 75.7639 9.80512C78.2273 7.02292 81.2819 5.94967 84.9276 6.58536ZM70.0019 6.65182C73.1767 7.88795 75.03 10.1916 75.5617 13.5626C75.7939 15.7615 75.3558 17.8182 74.2473 19.7327C72.1058 22.667 69.2559 23.7669 65.6975 23.0322C62.2485 21.8893 60.3303 19.5118 59.9429 15.8998C59.9889 11.8706 61.801 8.9538 65.3792 7.14961C66.8741 6.51147 68.4149 6.34553 70.0019 6.65182ZM78.8857 25.9731C79.4746 26.1028 80.0471 26.2845 80.6031 26.518C80.6887 26.9362 80.7743 27.3544 80.8599 27.7726C79.8833 27.6238 78.9349 27.3697 78.0148 27.0103C78.3255 26.6784 78.6158 26.3327 78.8857 25.9731ZM64.4682 24.1428C65.0571 24.2726 65.6296 24.4543 66.1856 24.6877C66.2712 25.1059 66.3568 25.5241 66.4424 25.9423C65.4658 25.7936 64.5174 25.5395 63.5973 25.18C63.908 24.8481 64.1983 24.5024 64.4682 24.1428Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M84.4307 7.80749C84.7205 7.88515 85.0103 7.96278 85.3001 8.04043C85.1801 8.48827 85.0601 8.9361 84.9401 9.38394C82.4513 8.87413 80.3169 9.51631 78.5369 11.3105C78.3799 11.4505 78.2645 11.6173 78.1911 11.8108C77.901 11.6844 77.636 11.5145 77.3959 11.3012C77.2267 11.2016 77.1232 11.0609 77.0855 10.8792C79.0066 8.57782 81.4551 7.55392 84.4307 7.80749Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M68.9518 7.72572C69.2152 7.7963 69.4787 7.8669 69.7421 7.93748C69.6221 8.38532 69.5021 8.83315 69.3821 9.28099C67.0885 8.8792 65.2175 9.59193 63.7692 11.4193C63.4016 11.1251 63.0463 10.8181 62.7031 10.4984C64.3092 8.49066 66.3921 7.56647 68.9518 7.72572Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M62.286 11.1066C62.671 11.3401 63.0643 11.5585 63.4658 11.7615C63.2903 12.1648 63.1247 12.5721 62.9689 12.9836C62.5375 12.8061 62.1038 12.6333 61.6678 12.4656C61.8253 11.9893 62.0314 11.5363 62.286 11.1066Z"
        fill={frameColor}
      />
      <rect
        x="18"
        y="39"
        width="60"
        height="60"
        rx="2"
        fill={frameBackgroundColor}
      />
      <foreignObject
        width="52%"
        height="49px"
        style={{ borderRadius: "3px" }}
        x="23"
        y="44">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="102">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
